var _path, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#326a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "327b",
    width: 36,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.154 0H3.384C1.516 0 0 .955 0 2.133v11.734C0 15.045 1.515 16 3.385 16h28.769c1.87 0 3.384-.955 3.384-2.133V2.133C35.539.955 34.024 0 32.155 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#327b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#003495",
    fillRule: "evenodd",
    d: "m0 0 22 8.533H10.154L22 16H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF0A37",
    fillRule: "evenodd",
    d: "m1.692 2.133 13.539 5.333H5.077l11.846 7.467H3.381c-.93 0-1.689-.487-1.689-1.069z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.318 5.332c.093.083.144.173.144.267 0 .441-1.138.8-2.539.8s-2.538-.359-2.538-.8q.002-.142.144-.267c.348.156 1.29.267 2.394.267s2.048-.111 2.395-.267",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.923 13.868c1.402 0 2.539-.716 2.539-1.6s-1.137-1.6-2.539-1.6-2.538.716-2.538 1.6 1.136 1.6 2.538 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M2.982 1.39C1.802.918.846 1.254.846 2.131V13.87c0 .882 1.13 1.598 2.544 1.598h16.918L8.462 8h11z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "326a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagNp = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagNp);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";